// extracted by mini-css-extract-plugin
export default {"linkPreview":"linkPreview--DYVET"};